import gql from 'graphql-tag'

export const getExports = gql`
  query($paging: PagingQuery!, $type: ExportType!) {
    getExports(
      type: $type,
      paging: $paging
    ) {
      exports {
        id
        notes
        type
        status
        createdAt
        filterStr
        createdBy {
          id
          username
        }
        file {
          id
          size
          name
        }
      }
      paging{ totalCount currentOffset currentLimit }
    }
  }
`

export const deleteExport = gql`
  mutation($exportId: Int!) {
    deleteExport(
      exportId: $exportId
    )
  }
`
